import { useState } from "react";
import { ApiResponse, CustomServiceFormat, WordData, WordCategoryData } from "../../interfaces/api-response";
import axiosInstance from "../Axios/axiosInstance";
import { url_word } from "./useApiUrl";

// Servicio para obtener la palabra
export const useWordService = (): CustomServiceFormat<ApiResponse<WordData>, 'content', 'loading', 'error'> => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const content = async (): Promise<ApiResponse<WordData> | undefined> => {
        setLoading(true);
        setError(null);

        try {
            const response = await axiosInstance.get<ApiResponse<WordData>>(`${url_word}/active`);
            const result = response.data;
            setLoading(false);
            return result;
        } catch (error: any) {
            setError(error.response ? error.response.data.msg : error.message);
            setLoading(false);
            return undefined;
        }
    };

    return { content, loading, error };
};


// Servicio para obtener la palabra por categorías
export const useWordCategoryService = (num: number): CustomServiceFormat<ApiResponse<WordCategoryData>, 'content', 'loading', 'error'> => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const content = async (): Promise<ApiResponse<WordCategoryData> | undefined> => {
        setLoading(true);
        setError(null);

        try {
            const response = await axiosInstance.get<ApiResponse<WordCategoryData>>(`${url_word}/categories/active/${num}`);
            const result = response.data;
            setLoading(false);
            return result;
        } catch (error: any) {
            setError(error.response ? error.response.data.msg : error.message);
            setLoading(false);
            return undefined;
        }
    };

    return { content, loading, error };
};


// Servicio para obtener las palabras por nombre de Tag
export const useWordTagService = (name: string): CustomServiceFormat<ApiResponse<WordData>, 'content', 'loading', 'error'> => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const content = async (): Promise<ApiResponse<WordData> | undefined> => {
        setLoading(true);
        setError(null);

        try {
            const response = await axiosInstance.get<ApiResponse<WordData>>(`${url_word}/tag/active/${name}`);
            const result = response.data;
            setLoading(false);
            return result;
        } catch (error: any) {
            setError(error.response ? error.response.data.msg : error.message);
            setLoading(false);
            return undefined;
        }
    };

    return { content, loading, error };
};


// Servicio para obtener la palabra completo por categoria
export const useWord_id_categoryService = (id_category: number): CustomServiceFormat<ApiResponse<any>, 'content', 'loading', 'error'> => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const content = async (): Promise<ApiResponse<any> | undefined> => {
        setLoading(true);
        setError(null);

        try {
            const response = await axiosInstance.get<ApiResponse<any>>(`${url_word}/category/active/${id_category}`);
            const result = response.data;
            setLoading(false);
            return result;
        } catch (error: any) {
            setError(error.response ? error.response.data.msg : error.message);
            setLoading(false);
            return undefined;
        }
    };

    return { content, loading, error };
};
